import React, { useEffect, useState } from 'react';
import { Container, Box, Typography, Alert, CircularProgress } from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';  // Ajuste o caminho conforme seu projeto

const VerifyEmailPage = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const { verifyEmail } = useAuth(); // Certifique-se que seu hook retorna esta função
  const [status, setStatus] = useState({ loading: true, error: '', success: '' });

  useEffect(() => {
    const verificar = async () => {
      try {
        const resp = await verifyEmail(token);
        setStatus({ loading: false, error: '', success: resp.mensagem || 'Email verificado!' });
        // Redireciona após alguns segundos se quiser
        setTimeout(() => navigate('/login'), 3000);
      } catch (err) {
        setStatus({ loading: false, error: err.message, success: '' });
      }
    };
    verificar();
  }, [token, verifyEmail, navigate]);

  if (status.loading) {
    return (
      <Container maxWidth="xs">
        <Box sx={{ mt: 8, textAlign: 'center' }}>
          <CircularProgress />
          <Typography variant="h6" sx={{ mt: 2 }}>Verificando seu email...</Typography>
        </Box>
      </Container>
    );
  }

  return (
    <Container component="main" maxWidth="xs">
      <Box sx={{ mt: 8, textAlign: 'center' }}>
        {status.error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {status.error}
          </Alert>
        )}
        {status.success && (
          <Alert severity="success" sx={{ mb: 2 }}>
            {status.success}
          </Alert>
        )}
      </Box>
    </Container>
  );
};

export default VerifyEmailPage;
